<template>
    <div class="mb-3 c-multiselect">
        <label class="c-multiselect-label mb-2">{{ title }}</label>
        <multiselect
            :value="value"
            @input="$emit('input', $event)"
            :options="options"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :placeholder="lang === 'en' ? 'All' : 'Alle'"
            :label="lang === 'en' ? label_en : label"
            :track-by="trackBy"
            :preselect-first="false"
            :searchable="false"
            :showPointer="false"
            :showLabels="false"
            class="mt-2"
            :maxHeight="500"
            openDirection="bottom"
        >
            <template slot="selection" slot-scope="{ values, search, isOpen }"
                ><span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }}
                    <template v-if="lang === 'en'">selected</template
                    ><template v-else>ausgewählt</template></span
                ></template
            >
        </multiselect>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
    components: { Multiselect },
    props: {
        title: {
            required: true,
            type: String,
        },
        value: {
            required: true,
            type: Array,
        },
        options: {
            required: true,
            type: Array,
        },
        label: {
            required: true,
            type: String,
        },
        label_en: {
            required: true,
            type: String,
        },
        trackBy: {
            required: true,
            type: String,
        },
    },
    computed: {
        ...mapState(["lang"]),
    },
};
</script>

<style lang="scss">
.c-multiselect {
    .c-multiselect-label {
        font-size: 13px;
        text-transform: uppercase;
        font-weight: bold;
    }
    .multiselect {
        font-size: 14px;
        &__tags {
            border-radius: 20px;
        }
        &__tag {
            background: $grey-darker;
        }
        &__tag-icon:focus,
        &__tag-icon:hover {
            background: $grey-darkest;
        }
        &__tag-icon:after {
            color: black;
        }
        &__content-wrapper {
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;
            max-height: none !important;
        }
        &__select:before {
            top: 0;
            border-color: $grey-darker;
            border-width: 0 2px 2px 0;
            display: inline-block;
            padding: 3px;
            margin-top: 9px;
            transform: rotate(45deg);
        }
        &__placeholder {
            display: block;
            margin-top: -2px;
            margin-left: 7px;
            padding-top: 0px;
            margin-bottom: 0px;
        }
        &__option {
            padding-left: 12px;
            padding-right: 12px;
        }
        &__element {
            display: block;
            border-bottom: 1px solid $grey;
            // margin-left: 12px;
            // margin-right: 12px;
        }
        &__element:last-child {
            border-bottom: none;
        }

        &--active {
            .multiselect__tags {
                border-bottom: none;
            }
        }
    }
}
</style>
